// The innate Math.max and Math.min actually crash with bigger arrays
// hence these custom functions
export function getMin(arr: number[]) {
  let len = arr.length;
  let min = Infinity;

  while (len--) {
    min = arr[len] < min ? arr[len] : min;
  }
  return min;
}

export function getMax(arr: number[]) {
  let len = arr.length;
  let max = -Infinity;

  while (len--) {
    max = arr[len] > max ? arr[len] : max;
  }
  return max;
}

export function getMinAndMax(arr: number[]): { min: number; max: number } {
  let len = arr.length;
  let max = -Infinity;
  let min = Infinity;

  while (len--) {
    min = arr[len] < min ? arr[len] : min;
    max = arr[len] > max ? arr[len] : max;
  }
  return { min, max };
}
